// Цвет сегмента фигуры по % нормы, как в DDX.

export type FigureMode = 'lean' | 'fat'

const BELOW = '#12D8D8'
const NORMAL = '#12B76A'
const ABOVE = '#FF7D20'
const UNKNOWN = 'var(--border)'

/** Границы нормы в % (стандарт InBody): мышцы 90–110, жир 80–160. */
const NORM_PCT: Record<FigureMode, readonly [number, number]> = { lean: [90, 110], fat: [80, 160] }

export function segmentColor(pct: number | null | undefined, mode: FigureMode): string {
  if (pct === null || pct === undefined || !Number.isFinite(pct)) return UNKNOWN
  const [low, high] = NORM_PCT[mode]
  if (pct < low) return BELOW
  if (pct > high) return ABOVE
  return NORMAL
}
